const en_return_customer_type = {
    "": "Customer Return Type",
    add: "Add Customer Return Type",
    edit: "Edit Customer Return Type",

    label: {
        name: "Type Name",
        commission: "Commission Deduction ( % )",
    },

    error: {
        name: "Type name is required.",
        create: "Failed to create customer return type.",
        delete: "Failed to delete customer return type.",
        edit: "Failed to update customer return type.",
    },

    success: {
        create: "Customer return type created successfully.",
        delete: "Customer return type deleted successfully.",
        edit: "Customer return type updated successfully.",
    },
}
export default en_return_customer_type;